export default "__VITE_PUBLIC_ASSET__5aa6aa73__"